import {Component, OnDestroy, OnInit} from '@angular/core';
import {Website} from "../website";
import {ActivatedRoute} from '@angular/router';
import {User} from "../../../user/user";
import {WebsiteService} from "../../website.service";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {Subscription} from "rxjs";
import {HostingService} from "../hosting/hosting.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-advanced-tools',
    templateUrl: './advancedTools.component.html',
    styleUrls: ['./advancedTools.component.scss'],
    standalone: false
})
export class AdvancedToolsComponent implements OnInit, OnDestroy {
  public website: Website;
  public user: User;
  public advancedTools: FormGroup;
  public loading: boolean;
  private subscriptions: Subscription[];

  constructor(
    private _route: ActivatedRoute,
    private _websiteService: WebsiteService,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this.user = this._route.snapshot.parent.parent.data['user'];
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.advancedTools = new FormGroup({
      'searchString': new FormControl('', [Validators.required]),
      'replaceString': new FormControl('', [Validators.required])
    });
    this.addEventHandlers();
  }

  public ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private addEventHandlers(): void {
    this.subscriptions = [];
  }

  private removeEventHandlers(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.subscriptions = null;
  }

  public replaceUrl() {
    if (this.advancedTools.valid) {
      this.loading = true;
      this._hostingService.replaceSiteUrls(this.website.id, this.advancedTools.value)
        .pipe(filter((response: DbResponse): boolean => !!response),
          first())
        .subscribe((response: DbResponse): void => {
          if (response.success) {
            NotifierComponent.notify(new Notification(response.message, NotificationType.SUCCESS));
          }
          else {
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }
          this.loading = false;
        });
    }
  }

}
